export const auth = (state = { name: 'subash' }, action) => {
  return state;
};
